import ArrowRight from 'iconsax-react/dist/esm/ArrowRight';
import React from 'react';
import { useLocation, useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { resolveLocalizedText } from '../../../helpers/resolveLocalizedText';
import { LANDING_PAGE_PLACEHOLDERS } from 'tdr-common';
import { analytics, NAVIGATE_TO_PARAMS } from '../../../helpers/analytics';
import { getPatioSection } from '../../../helpers/getPatioSection';
import { useScreenSize } from '../../../hooks/useScreenSize';
import { getExploreEntryPath } from '../../../helpers/open-parameters/getExploreEntryPath';
import { RestaurantGuardOutletContext } from '../../../routes/RestaurantGuard';
import { ProceedWithLogo } from '../../logos/ProceedWithLogo';
import { BookingOptionTileWidgetVersion } from '../BookingOptionTileWidgetVersion';
import { AnimatedImageGallery } from '../../animated-image-gallery/AnimatedImageGallery';
import styles from './BookWithTablz.module.scss';

export const RightArrowIcon = () => {
	return (
		<div className={styles.IconContainer}>
			<ArrowRight />
		</div>
	);
};

export const BookWithTablz = () => {
	const { i18n } = useTranslation();
	const location = useLocation();
	const { featureFlags, tables, restaurant } = useOutletContext<RestaurantGuardOutletContext>();
	const { isSmallScreen } = useScreenSize();

	const patioExists = Boolean(getPatioSection(tables));

	const handleClick = () => {
		analytics.track('home_proceed');
		analytics.track(NAVIGATE_TO_PARAMS, {
			from: 'Book With Tablz'
		});
	};

	const getLinkTo = () => {
		const useSeating =
			(featureFlags?.patio && patioExists) || !!restaurant.settings?.alternativeBookingOption?.label;
		const basePath = useSeating ? 'seating' : getExploreEntryPath(isSmallScreen);
		return location.search ? `${basePath}${location.search}` : basePath;
	};

	const title = resolveLocalizedText(restaurant.settings?.landingPage?.tablz?.title, i18n.language) || LANDING_PAGE_PLACEHOLDERS.tablz.title;
	const description = resolveLocalizedText(restaurant.settings?.landingPage?.tablz?.description, i18n.language) || LANDING_PAGE_PLACEHOLDERS.tablz.description;
	const callToAction = resolveLocalizedText(restaurant.settings?.landingPage?.tablz?.callToAction, i18n.language) || LANDING_PAGE_PLACEHOLDERS.tablz.callToAction;

	return (
		<BookingOptionTileWidgetVersion
			title={title}
			description={description}
			backgroundImage={<AnimatedImageGallery restaurant={restaurant} tables={tables} />}
			icon={<RightArrowIcon />}
			platformLogo={<ProceedWithLogo logo='tablz--gold' />}
			linkTo={getLinkTo()}
			onClick={handleClick}
			label={callToAction}
			variant='primary'
		/>
	);
};
